import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { map, uniqueId } from 'lodash';

import { ButtonGroup, Buttons } from './styled-components/radioButtonStyles';

const RadioButton = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const Checkmark = styled.span`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border: thin solid #d5d5d5;

  &:hover {
    background-color: #d5d5d5;
  }

  &:after {
    content: '';
    position: absolute;
    top: 3.5px;
    left: 3.5px;
    width: 50%;
    height: 50%;
    border-radius: 50%;
  }
`;

const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  > input:checked ~ span {
  }

  > input:hover ~ span {
    background: #eee;
  }

  > ${RadioButton}:checked ~ ${Checkmark}:after {
    display: block;
    background: ${({ theme }) => theme.iconColor};
  }

  &:after {
    top: 9px;
    left: 9px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
  }
`;

const NewRadioButton = ({
  data, name, onChange, selectedIndex, preformatted, ...props
}) => (
  <ButtonGroup>
    {map(data, (button, index) => (
      <Buttons key={`${uniqueId('radioButton')}.${index}`} {...props}>
        <Label
          htmlFor={`${uniqueId('button_')}.${button.value}`}
          onClick={() => onChange(button.value)}
        >
          {preformatted ? button.text : <FormattedMessage id={button.text} />}
          <RadioButton
            onChange={() => onChange(button.value)}
            id={`${uniqueId('button_')}.${button.value}`}
            name={name}
            checked={selectedIndex === index}
            type="radio"
            value={button.value}
          />
          <Checkmark />
        </Label>
      </Buttons>
    ))}
  </ButtonGroup>
);

NewRadioButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  preformatted: PropTypes.bool,
};

NewRadioButton.defaultProps = {
  preformatted: false,
};

export default NewRadioButton;
